import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

// Wraps children with the reCAPTCHA Enterprise script/context. Renders children
// unwrapped when the key isn't configured so a missing env var can't crash the page.
export const RecaptchaProvider = ({ children }) => {
  if (!RECAPTCHA_SITE_KEY) {
    return children;
  }
  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY} useEnterprise>
      {children}
    </GoogleReCaptchaProvider>
  );
};
